import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { ActivatedRoute } from '@angular/router';
import { DesksTurnsService } from 'src/app/services/turns-services/desks-turns-service/desks-turns.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { Schedule } from 'src/app/models/schedule-models/schedule.model';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';

@Component({
  selector: 'app-turns-desk-schedule-dashboard',
  templateUrl: './turns-desk-schedule-dashboard.component.html',
  styleUrls: ['./turns-desk-schedule-dashboard.component.scss']
})
export class TurnsDeskScheduleDashboardComponent implements OnInit, OnDestroy {

  deskid;
  schedule: Schedule;
  getDeskScheduleSubscription: Subscription;

  constructor(private desksTurnsService: DesksTurnsService,
              private userStorageService: UserStorageService,
              private activatedRoute: ActivatedRoute,
              private snackbarService: SnackBarService,
              private headerBreadcrumbService: HeaderBreadcrumbService) { }

  ngOnInit() {
    this.deskid = this.activatedRoute.snapshot.params['deskid'];
    this.setBreadcrumb();
    this.getSchedule();
  }

  public getSchedule() {
    const internalId = this.activatedRoute.snapshot.params['scheduleid'];
    const relatedEntityInternalId = this.activatedRoute.snapshot.params['deskid'];
    this.getDeskScheduleSubscription = this.desksTurnsService.getDeskScheduleInfo(internalId, relatedEntityInternalId).subscribe(
      (res) => {
        if (res['data']['calendarDetail']) {
          const schedule = new Schedule();
          Object.assign(schedule, res['data']['calendarDetail']);
          this.schedule = schedule;
        }
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-calendar-day', 'schedule-page.schedule detail', '/turns/desk/' + this.deskid, [new BRoute('turns-page.turns', '/turns'), new BRoute('turns-page.desks', '/turns/desks'), new BRoute('turns-page.desk detail', '/turns/desk/' + this.deskid), new BRoute('schedule-page.schedule detail')]));
  }

  ngOnDestroy() {
    if (this.getDeskScheduleSubscription) { this.getDeskScheduleSubscription.unsubscribe(); }
  }
}
